import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { BrandLogo } from "@/components/Brand";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";

export default function Login() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const [li, setLi] = useState({ email: "", password: "" });
  const [rg, setRg] = useState({ name: "", email: "", password: "" });

  const go = (user) => nav(user.role === "OWNER" || user.role === "ADMIN" ? "/admin" : "/app");

  const doLogin = async (e) => {
    e.preventDefault(); setLoading(true);
    try { const u = await login(li.email, li.password); toast.success("Welcome back"); go(u); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const doRegister = async (e) => {
    e.preventDefault(); setLoading(true);
    try { const u = await register({ ...rg, role: "PLACEMENT_PROFESSIONAL" }); toast.success("Account created"); go(u); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center"><BrandLogo light /></Link>
        <Card className="mt-8 p-8" data-testid="login-card">
          <Tabs defaultValue="login">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="login" data-testid="tab-login">Login</TabsTrigger>
              <TabsTrigger value="register" data-testid="tab-register">Create account</TabsTrigger>
            </TabsList>

            <TabsContent value="login" className="mt-6">
              <form onSubmit={doLogin} className="space-y-4" data-testid="login-form">
                <div>
                  <Label>Email</Label>
                  <Input data-testid="login-email" type="email" required className="mt-1" value={li.email} onChange={(e) => setLi({ ...li, email: e.target.value })} />
                </div>
                <div>
                  <Label>Password</Label>
                  <Input data-testid="login-password" type="password" required className="mt-1" value={li.password} onChange={(e) => setLi({ ...li, password: e.target.value })} />
                </div>
                <Button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full bg-clinical hover:bg-clinical/90">
                  {loading ? "Signing in…" : "Sign in"}
                </Button>
              </form>
            </TabsContent>

            <TabsContent value="register" className="mt-6">
              <form onSubmit={doRegister} className="space-y-4" data-testid="register-form">
                <div>
                  <Label>Full name</Label>
                  <Input data-testid="register-name" required className="mt-1" value={rg.name} onChange={(e) => setRg({ ...rg, name: e.target.value })} />
                </div>
                <div>
                  <Label>Email</Label>
                  <Input data-testid="register-email" type="email" required className="mt-1" value={rg.email} onChange={(e) => setRg({ ...rg, email: e.target.value })} />
                </div>
                <div>
                  <Label>Password</Label>
                  <Input data-testid="register-password" type="password" required className="mt-1" value={rg.password} onChange={(e) => setRg({ ...rg, password: e.target.value })} />
                </div>
                <Button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full bg-navy hover:bg-navy/90">
                  {loading ? "Creating…" : "Create placement professional account"}
                </Button>
              </form>
            </TabsContent>
          </Tabs>
        </Card>
        <p className="mt-6 text-center text-sm text-slate-400">
          Not a member yet? <Link to="/join" className="font-semibold text-white hover:underline">Join Care Placement Pro</Link>
        </p>
      </div>
    </div>
  );
}
